export const HeaderTableNotAllowedCountryForCompany = [
  'Company ID',
  'Company Name',
  'Country Not Allowed',
  'Action',
];
